import React from "react";
import { GridColumn, Typography } from "@sumprio/ui";

export interface DetailFieldProps {
  label: string;
  children: React.ReactNode;
  valueBodySize?: "xs" | "sm" | "md";
  valueBodyWeight?: "regular" | "medium";
  gridSpan?: number;
  gridSpanTablet?: number;
  gridSpanMobile?: number;
}

export default function DetailField({
  label,
  children,
  valueBodySize = "sm",
  valueBodyWeight = "medium",
  gridSpan = 2,
  gridSpanTablet,
  gridSpanMobile,
}: DetailFieldProps) {
  return (
    <GridColumn span={gridSpan} spanTablet={gridSpanTablet} spanMobile={gridSpanMobile} gap="md">
      <Typography variant="body" bodySize="xs" bodyWeight="regular" color="secondary">
        {label}
      </Typography>
      {typeof children === "string" ? (
        <Typography
          variant="body"
          bodySize={valueBodySize}
          bodyWeight={valueBodyWeight}
          style={{ overflowWrap: "anywhere" }}
        >
          {children}
        </Typography>
      ) : (
        <span style={{ overflowWrap: "anywhere" }}>{children}</span>
      )}
    </GridColumn>
  );
}
